import { observer } from "mobx-react";
import { getRoot } from "mobx-state-tree";
import { format, isValid } from "date-fns";
import { Button } from "@humansignal/ui";
import { cn } from "@afriannotate/datamanager/utils/bem";
import { Contributor, PhotoStack } from "./RecordCells";
import "./RecordGrid.prefix.css";

const block = cn("record-grid");

const REVIEW = { accepted: "Accepted", rejected: "Rejected", fixed: "Fixed" };

const saved = (value) => {
  const d = new Date(value);
  return value && isValid(d) ? format(d, "MMM dd yyyy, HH:mm") : "";
};

/** Grid view of records (open collection): one card per record with its
 *  photo, answers, contributor, time and review state. The task grid shows
 *  task data fields, which records do not have. */
export const RecordGrid = observer(({ view, data, loadMore }) => {
  const root = getRoot(view);
  const total = view.dataStore?.total ?? data.length;
  return (
    <div className={block.toClassName()}>
      <ul className={block.elem("cards").toClassName()}>
        {data.map((row) => {
          const selected = view.selected.isSelected(row.id);
          return (
            <li key={row.id} className={block.elem("card").mod({ selected }).toClassName()}>
              <label className={block.elem("check").toClassName()}>
                <input
                  type="checkbox"
                  checked={selected}
                  onChange={() => view.toggleSelected(row.id)}
                  aria-label={`Select record ${row.id}`}
                />
              </label>
              <button
                type="button"
                className={block.elem("open").toClassName()}
                onClick={() => root.startLabeling(row)}
                aria-label={`Open record ${row.id}`}
              >
                <span className={block.elem("media").toClassName()}>
                  {row.photo ? (
                    <PhotoStack
                      photos={[row.photo]}
                      total={row.extra?.photos?.length}
                      fallback={row.extra?.photo_full}
                      size="card"
                    />
                  ) : (
                    <span className={block.elem("nomedia").toClassName()}>{row.media || "No media"}</span>
                  )}
                </span>
                <span className={block.elem("answers").toClassName()}>{row.answers || "No answers"}</span>
                <span className={block.elem("prompt").toClassName()}>{row.prompt}</span>
                <span className={block.elem("foot").toClassName()}>
                  <Contributor user={row.extra?.contributor_user} name={row.contributor} />
                  <span
                    className={block
                      .elem("review")
                      .mod({ state: row.review_state || "none" })
                      .toClassName()}
                  >
                    {row.review_state ? (REVIEW[row.review_state] ?? "Reviewed") : "Not reviewed"}
                  </span>
                </span>
                <span className={block.elem("meta").toClassName()}>
                  Record {row.id}
                  {saved(row.created_at) ? `, ${saved(row.created_at)}` : ""}
                </span>
              </button>
            </li>
          );
        })}
      </ul>
      {data.length < total ? (
        <div className={block.elem("more").toClassName()}>
          <Button look="outlined" size="small" onClick={() => loadMore?.()}>
            Load more ({data.length} of {total})
          </Button>
        </div>
      ) : null}
    </div>
  );
});
